import { GlobalService } from "@commoncore/services/global.service";
import { DigiLockerDocumentsType } from "@commoncore/services/universal.service";
import { MultiSelectLibrary } from "@commoncore/utils/MultiSelectUtil";
import { AppEvents } from "@commoncore/utils/app-events";

export class DigiLockerImplementation {
  public router: any;
  public http: any;
  public route: any;
  public customMetadata: any;
  public universalService: any;
  static singleInstance: DigiLockerImplementation;
  private digiLockerStorageType = "DIGILOCKER"
  private appCode = "dgl";
  private authCode = "";
  private digiKey = "";
  private fetchedDocumentsData: any;
  public accountsList: any = [];
  public documentsList: any = [];
  private digiLockerRootFolderKey = "";
  multiSelect: any;

  constructor(public globalService: GlobalService) {
    this.setHandler(this.globalService);
  }

  public static getInstance(globalService): DigiLockerImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new DigiLockerImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public setHandler(globalService) {
    this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.universalService = globalService.getUniversalServiceRef();
    this.route = globalService.getActivatedRoute();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
  }

  loginOnDigiLocker(url, storageType) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        suc => {
          self.universalService.showLoader = false;
          resolve({ register: true, resp: suc });
        },
        err => {
          console.log("error from login on digiLocker API", err);
          self.universalService.showLoader = false;
          reject({ register: false, resp: err });
        }
      )
    })
  }

  getLinkedAccountDetails(url, isRoot = false, objectType) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        suc => {
          if (!isRoot) {
            suc.objects = suc.objects.filter( obj => {
              return obj.objectType === "FE";
            })
          }
          let filesList = self.customMetadata.segregateData(suc,"allfiles"); 
          //var filteredObjects =  self.filterOutRequiredContent(suc, "FR")
          if (!isRoot) {//if not root, set data in accountList
            if(objectType == "FR") { //set folder list
              self.setRequiredDataInAccountsList(filesList);
            } else { //files
              self.setRequiredDataInDocumentsList(filesList);
              self.bindMultiSelect(filesList); 
            }
          }  else {//if root, save key
            if(filesList && filesList[0]) {//if objects exists, then hold root key
              self.digiLockerRootFolderKey = filesList[0].objectKey;
            }
          }
          self.universalService.showLoader = false;
          resolve({ "metadata": filesList });
        },
        err => {
          console.log("error from getLinkedAccountDetails API", err);
          self.universalService.showLoader = false;
          reject({ "metadata": undefined });
        }
      )
    })
  }
  //Get respective  account documents list
  getDigiLockerDocumentMetaData(url) {
    var self = this;
    return new Promise(function (resolve, reject) {
      self.http.get(url).subscribe(
        suc => {
          //var filteredObjects =  self.filterOutRequiredContent(suc, "FR")  
          let docsList = this.customMetadata.segregateData(suc,"allfiles");     
          self.universalService.showLoader = false;
          resolve({ "metadata": docsList });
        },
        err => {
          console.log("error from getDigiLockerDocumentMetaData API", err);
          self.universalService.showLoader = false;
          reject({ "metadata": undefined });
        }
      )
    })
  }

  resetFilesData() {
    this.digiLockerRootFolderKey = "";
    this.accountsList = [];
    this.documentsList = [];
    this.universalService.objectsPreviewArray = [];
  }

  resetAuthDetails() {
    this.authCode = "";
    this.digiKey = "";
  }

  //metadata gives files/folder - we need to filter based on view
  filterOutRequiredContent(response, type) {
    if (response && response.objects) {
      let objectList = response.objects.filter(function (obj) {
        return (obj.objectType == type && obj.parentObjectType == type);
      });
      return objectList;
    }
  }
  //set data as per format
  async setRequiredDataInAccountsList(accountsList) {
    this.accountsList = accountsList;
  }

  //set data as per format
  async setRequiredDataInDocumentsList(docsList) {
    this.documentsList = docsList;
    if(this.documentsList.length == 0) {
      this.universalService.emptyTab = true;
    }
  }

  fetchDigiLockerDocuments(url) {
    var self = this;
    self.universalService.showLoader = true;
    let params = {
      "authCode": self.authCode
    }
    return new Promise(function (resolve, reject) {
      self.http.post(url, params).subscribe(
        info => {
          self.fetchedDocumentsData = info.documents;
          self.digiKey = info.digiKey;
          self.universalService.showLoader = false;
          resolve({fetched:true,resp:info});
        },
        err => {

          // var data = JSON.parse('{"digiKey":"cc37ecd9d4a14a8caab05ab71c1df4d1","documents":[{"docType":"DRVLC","isIssued":"Y"}]}')
          // self.fetchedDocumentsData = data.documents;
          // self.digiKey = data.digiKey;
          console.log('fetchDigiLockerDocuments err', err);
          self.universalService.showLoader = false;
          reject({fetched:false,resp:err});
        }
      )
    })
  }

  addDigiLockerDocsToJC(url) {
    var self = this;

    let params = {
      "digiKey": self.digiKey
    }
    return new Promise(function (resolve, reject) {
      self.http.post(url, params).subscribe(
        info => {
          self.universalService.showLoader = false;
          resolve({ isAdded: true, resp: info });
          
        },
        err => {
          console.log('addDigiLockerDocsToJC err', err);
          self.universalService.showLoader = false;
          reject({ isAdded: false, resp: err });
        }
      )
    })
  }

  getDocumentDescription(type) {
    return DigiLockerDocumentsType[type]
  }

  bindMultiSelect(obj){
    setTimeout(() => {  
      this.multiSelect = MultiSelectLibrary.getInstance(this.globalService);
      this.multiSelect.bindMultiSelectLibrary(".main-digilocker-container", "grid_info", ".gridItem:visible", true,false,false);
      this.multiSelect.bindMultiSelectUIevent(".tab-content", ".grid_file_child");  
      AppEvents.multiSelectEvent.next({"dataArray":obj})
    }, 100);
  }

  updateDeletedDocuments(filesList, deletedFiles) {
    var self = this;
    deletedFiles.map(file=>{ // for each object in the list
      var find = filesList.find(obj=>obj["objectKey"] == file["objectKey"]);
      if(find){
        var index = filesList.indexOf(find);  //find the index of object in the folders array
        if(index>=0){
          filesList.splice(index,1)
        }
      }    
    });

    return filesList;
  }

}
